(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao')
    .controller('ModalInstanceExclusaoAgendamento', ModalInstanceExclusaoAgendamento);

  function ModalInstanceExclusaoAgendamento($uibModalInstance, parametros,
    AgendamentoService, toaster, i18n) {

    var vm = this;
    vm.parametros = parametros;
    vm.cancelar = cancelar;
    vm.excluirAgendamento = excluirAgendamento;

    function cancelar() {
      $uibModalInstance.dismiss('cancel');
    }

    function excluirAgendamento() {
      AgendamentoService.excluirAgendamento(vm.parametros.idAgendamento)
      .then(() => {
        $uibModalInstance.close();
        toaster.pop("success",
          i18n.translate("menu.agendamento.relatorio.eleitoral"),
          i18n.translate("relatorio.eleitoral.exclusao.sucesso"));
      }).catch( () => {
        $uibModalInstance.dismiss();
      });
    }
  }
})();
